import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Card,
  CardBody,
  Badge,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
  CardHeader,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import ChatHeading from "../../../containers/pages/message/ChatHeading";
import MessageCard from "../../../containers/pages/message/MessageCard";
import FacebookChatApp from "../../../containers/pages/message/FacebookChatApp";
import FacebookCommentApp from "../../../containers/pages/message/FacebookCommentApp";import createSocket from "../../../helpers/createSocket";
import {
  buildStoredAuthPayload,
  createAuthHandoffUrl,
} from "../../../helpers/AuthHandoff";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import {
  NotificatioErrController,
  IsRedirectFromAlert,
  getAvatar,
  getUnSeen,
} from "../../../helpers/Utils";
import { PreviewContent } from "../../../containers/pages/message/Utils";
import { isF, isR } from "../../../helpers/Roles";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import moment from "moment";
import "moment/locale/vi";

moment.locale("vi");

const ROLE_ALIAS = "message";

class ChatApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainActiveTab: "all",
      menuActiveTab: "messages",
      USER_PARENT_ID: localStorage.getItem("b"),
      messageInput: "",
      selectedConversation: true,
      searchKey: "",
      inboxsData: [],
      originalInboxsData: undefined,
      conversationData: [],
      originalConversationData: [],
      selectedUser: null,
      allUsersData: [],
      files: null,
      isLoadedMore: false,
      isEndMessagesData: false,
      isFirstLoad: true,
      aboutProps: {
        message_item_id: 0,
        message_user_id: 0,
      },
      filterUnread: false, // Global Filter State
      facebookUnreadCount: 0,
    };

    this.socket = createSocket();
  }

  // Toggle Global Unread Filter
  toggleUnreadFilter = () => {
    this.setState((prevState) => ({
      filterUnread: !prevState.filterUnread,
    }));
  };

  // axios
  allUsersDataRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/message/all_contacts"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        this.setState({
          allUsersData: data.data,
          originalAllUsersData: data.data,
        });
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (IsRedirectFromAlert(this.props)) {
      if (!this.state.inboxsData.length) {
        // call get inbox
        this.socket.emit("message get inbox", {
          // user_id: localStorage.getItem('user_id'),
          user_id: this.state.USER_PARENT_ID,
        });
      } else {
        // [] ! null
        const { message_item_id, message_user_id } =
          this.props.location.aboutProps;
        const data = this.state.inboxsData;

        let selectedUserDefault = null;
        if (message_item_id.indexOf(".") >= 0) {
          // guest
          let table_chair_id = message_item_id.split(".")[0];
          let sender_id = message_item_id.split(".")[1];
          let receive_id = message_user_id;

          selectedUserDefault = data.filter(
            (ibx) =>
              ibx.sender_id == sender_id &&
              ibx.receive_id == receive_id &&
              ibx.table_chair_id == table_chair_id,
          );
        } else {
          // store
          selectedUserDefault = data.filter(
            (ibx) =>
              [ibx.friend_id, ibx.user_id].includes(
                parseInt(message_user_id),
              ) &&
              [ibx.friend_id, ibx.user_id].includes(parseInt(message_item_id)),
          );
        }
        selectedUserDefault = selectedUserDefault.length
          ? selectedUserDefault[0]
          : null;

        // get conversation
        if (selectedUserDefault) {
          if (prevState.selectedUser) {
            if (selectedUserDefault.id == prevState.selectedUser.id) {
              return;
            }
          }

          this.changeConversation(selectedUserDefault);

          // if (selectedUserDefault.sender_id) {
          //   // guest
          //   this.handleGetConversationGuest(selectedUserDefault);
          // }
          // else {
          //   // store
          //   this.handleGetConversation(selectedUserDefault)
          // }
        }
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.location && props.location.aboutProps) {
      const { message_item_id, message_user_id } = props.location.aboutProps;

      if (
        message_item_id &&
        message_user_id &&
        message_item_id != state.aboutProps.message_item_id &&
        message_user_id != state.aboutProps.message_user_id
      ) {
        return {
          aboutProps: {
            message_item_id: message_item_id,
            message_user_id: message_user_id,
          },
        };
      }
    }
    return null;
  }

  componentWillUnmount() {
    this.socket.close();
  }

  loadFacebookConversations = async () => {
    try {
      const response = await axios.get(
        `${END_POINT}/api/facebook/conversations?user_id=${this.state.USER_PARENT_ID}`,
      );
      const conversations = response.data.data || [];
      this.setState({ facebookConversations: conversations });
    } catch (err) {
      console.error(
        "Error loading Facebook conversations for Unified Tab:",
        err,
      );
    }
  };

  checkPermission = (requiredPackage) => {
    const { license } = this.state;
    if (!license) return false;

    const ranks = {
      free: 0,
      basic: 1,
      pro: 2,
      pro_auto: 3,
      enterprise: 4,
    };

    const currentPackage = (license.purchased_package || "free").toLowerCase();
    const currentRank = ranks[currentPackage] || 0;
    const requiredRank = ranks[requiredPackage] || 0;

    if (currentRank > 0 && license.expired_date) {
      const today = new Date().toISOString().split("T")[0];
      if (license.expired_date < today) {
        return 0 >= requiredRank;
      }
    }

    return currentRank >= requiredRank;
  };

  getLicense = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/user-license"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        const license = data.data;
        const ranks = {
          free: 0,
          basic: 1,
          pro: 2,
          pro_auto: 3,
          enterprise: 4,
        };
        const currentPackage = (license.purchased_package || "free").toLowerCase();
        const currentRank = ranks[currentPackage] || 0;

        let mainActiveTab = this.state.mainActiveTab;
        let isProOrAbove = currentRank >= 2;
        if (license.expired_date) {
          const today = new Date().toISOString().split("T")[0];
          if (license.expired_date < today) {
            isProOrAbove = false;
          }
        }

        if (!isProOrAbove) {
          mainActiveTab = "internal";
        }

        this.setState({
          license,
          mainActiveTab,
        }, () => {
          if (isProOrAbove) {
            this.loadFacebookConversations();
          }
        });
      })
      .catch((err) => {
        console.error("Error fetching license:", err);
      });
  };

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    if (searchParams.get("tab") === "fb-ads") {
      this.setState({ mainActiveTab: "fb-ads" });
    }

    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });
    this.socket.emit("join room", {
      room_id: this.state.USER_PARENT_ID,
    });

    this.socket.emit("message get inbox", {
      // user_id: localStorage.getItem('user_id'),
      user_id: this.state.USER_PARENT_ID,
    });

    this.socket.on("message get inbox", (res) => {
      const {
        data: { data },
      } = res;

      this.setState({
        inboxsData: data,
        originalInboxsData: data,
      });
    });

    // Listen for new Facebook messages to update Unified Tab
    this.socket.on("facebook message", (data) => {
      if (!this.checkPermission("pro")) return;
      // Optimistic update: immediately update facebookConversations state
      if (data && data.conversation_id) {
        this.setState((prevState) => {
          const existing = prevState.facebookConversations || [];
          const convExists = existing.some((c) => c.id === data.conversation_id);

          if (convExists) {
            // Update existing conversation in-place
            const updated = existing.map((c) => {
              if (c.id === data.conversation_id) {
                return {
                  ...c,
                  last_message: data.message?.message_text || "[Attachment]",
                  last_message_time: data.message?.timestamp || new Date().toISOString(),
                  is_read: false,
                };
              }
              return c;
            });
            // Re-sort by latest message
            updated.sort(
              (a, b) => new Date(b.last_message_time) - new Date(a.last_message_time),
            );
            return { facebookConversations: updated };
          }
          // New conversation — will be added by full refetch below
          return null;
        });
      }
      // Also do a full refetch for accuracy (e.g. new conversations)
      this.loadFacebookConversations();
    });

    this.socket.on("message get conversation", (res) => {
      const {
        data: { data, isEnd },
      } = res;

      if (this.state.selectedUser) {
        if (!data.length) return;

        let lastData = data[data.length - 1];

        // not update myself
        if (lastData.user_id != this.state.USER_PARENT_ID) {
          // console.log("Me received, update seen: ", lastData);

          this.socket.emit("message update seen conversation", {
            // user_id_will_alert: localStorage.getItem('user_id'),
            user_id_will_alert: this.state.USER_PARENT_ID,
            user_id: lastData.user_id,
            friend_id: lastData.friend_id,
            message: lastData,
          });
        }

        this.socket.emit("message get inbox", {
          // user_id: localStorage.getItem('user_id'),
          user_id: this.state.USER_PARENT_ID,
        });

        this.setState({
          conversationData: data,
          isLoadedMore: true,
          isEndMessagesData: isEnd,
        });
      }
    });

    this.socket.on("message get conversation guest", (res) => {
      const {
        data: { data, isEnd },
      } = res;
      // let id = localStorage.getItem("user_id");
      let id = this.state.USER_PARENT_ID;

      if (
        this.state.selectedUser &&
        (this.state.selectedUser.sender_id == id ||
          this.state.selectedUser.receive_id == id)
      ) {
        if (!data.length) return;

        let lastData = data[data.length - 1];

        if (
          IsRedirectFromAlert(this.props) ||
          (lastData.table_chair_id === this.state.selectedUser.table_chair_id &&
            (lastData.sender_id === this.state.selectedUser.sender_id ||
              lastData.sender_id === this.state.selectedUser.receive_id))
        ) {
          // not update myself
          if (lastData.sender_id != this.state.USER_PARENT_ID) {
            // console.log("GUEST: Me received, update seen: ", lastData);

            this.socket.emit("message update seen conversation guest", {
              user_id_will_alert: this.state.USER_PARENT_ID,
              user_id: this.state.USER_PARENT_ID,
              pin_id: lastData.sender_id,
              table_chair_id: lastData.table_chair_id,
              message: lastData,
            });
          }

          this.setState({
            conversationData: data,
            isLoadedMore: true,
            isEndMessagesData: isEnd,
          });
        }
      }

      this.socket.emit("message get inbox", {
        // user_id: localStorage.getItem('user_id'),
        user_id: this.state.USER_PARENT_ID,
      });
    });

    this.socket.on("message reload conversation", (res) => {
      const {
        id,
        data: { data },
      } = res;

      if (
        this.state.selectedUser &&
        (this.state.selectedUser.user_id == id ||
          this.state.selectedUser.friend_id == id)
      ) {
        if (!data.length) return;

        let lastData = data[data.length - 1];

        // not update myself
        if (lastData.user_id != this.state.USER_PARENT_ID) {
          // console.log("Me received, update seen: ", lastData);

          this.socket.emit("message update seen conversation", {
            user_id_will_alert: this.state.USER_PARENT_ID,
            user_id: this.state.USER_PARENT_ID,
            friend_id: id,
            message: lastData,
          });
        }
        this.setState({
          conversationData: data,
        });
      }

      this.socket.emit("message get inbox", {
        // user_id: localStorage.getItem('user_id'),
        user_id: this.state.USER_PARENT_ID,
      });
    });

    this.socket.on("broadcast", () => {
      // receive from broadcast

      const { selectedUser } = this.state;
      let selectedUserId = 0;
      if (selectedUser) {
        selectedUserId =
          selectedUser.user_id != this.state.USER_PARENT_ID
            ? selectedUser.user_id
            : selectedUser.friend_id;
      }

      // reload conversion
      if (selectedUserId) {
        this.socket.emit("message get conversation", {
          user_id: this.state.USER_PARENT_ID,
          friend_id: selectedUserId,
        });
      }

      // reload inbox
      this.socket.emit("message get inbox", {
        user_id: this.state.USER_PARENT_ID,
      });
    });

    // get all user data;
    this.allUsersDataRender();
    this.getLicense();
  }

  // Main conversion GUEST
  getConversationGuest = (selectedUser) => {
    let pin_id =
      selectedUser.sender_id != this.state.USER_PARENT_ID
        ? selectedUser.sender_id
        : selectedUser.receive_id;

    let offset = 0;
    if (this.state.conversationData) {
      offset = this.state.conversationData.length;
    }

    this.socket.emit("message get conversation guest", {
      user_id: this.state.USER_PARENT_ID,
      table_chair_id: selectedUser.table_chair_id,
      pin_id,
      offset,
    });
  };
  handleGetConversationGuest = (selectedUser) => {
    this.getConversationGuest(selectedUser);
    this.setState({ selectedUser, isLoadedMore: false });
  };
  handleSendToConversationGuest = () => {
    if (!isF(ROLE_ALIAS)) return false;

    let { messageInput, selectedUser } = this.state;

    let pin_id =
      selectedUser.sender_id != this.state.USER_PARENT_ID
        ? selectedUser.sender_id
        : selectedUser.receive_id;

    this.socket.emit("message send conversation guest", {
      user_id: this.state.USER_PARENT_ID,
      sender_id: this.state.USER_PARENT_ID,
      pin_id: pin_id,
      message: messageInput,
      table_chair_id: selectedUser.table_chair_id,
      real_id: localStorage.getItem("user_id"),
    });
  };

  // Main conversion
  // Files
  onChangeFile = (e) => {
    if (!isF(ROLE_ALIAS)) return false;

    if (e.target.files.length > 3) {
      NotificatioErrController(
        this.props.intl.formatMessage({ id: "chat.max_files_error" }),
      );
      return;
    }

    if (this.state.selectedUser.sender_id) {
      NotificatioErrController(
        this.props.intl.formatMessage({ id: "chat.no_file_guest_error" }),
      );
      return;
    }

    for (let i = 0; i < e.target.files.length; i++) {
      let file = e.target.files[i];

      if (file.size >= 100000000) {
        NotificatioErrController(
          this.props.intl.formatMessage({ id: "chat.file_size_error" }),
        );
        return;
      }
    }

    this.setState({ files: e.target.files });
  };
  onSelectedFile = (e) => {
    this.setState({ files: null });
  };
  handleSendFilesToConversation = (selectedUserId) => {
    if (!isF(ROLE_ALIAS)) return false;

    let { files } = this.state;

    // files
    for (let i = 0; i < files.length; i++) {
      let file = files[i];

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let arrayData = reader.result;

        let template = {
          name: file.name,
          type: file.type,
          size: file.size,
          data: arrayData,
        };

        this.socket.emit("message send conversation", {
          user_id: this.state.USER_PARENT_ID,
          friend_id: selectedUserId,
          file: template,
          real_id: localStorage.getItem("user_id"),
        });
      };
    }
  };

  getConversation = (selectedUser) => {
    let selectedUserId =
      selectedUser.user_id != this.state.USER_PARENT_ID
        ? selectedUser.user_id
        : selectedUser.friend_id;

    let offset = 0;
    if (this.state.conversationData) {
      offset = this.state.conversationData.length;
    }

    this.socket.emit("message get conversation", {
      user_id: this.state.USER_PARENT_ID,
      friend_id: selectedUserId,
      offset,
    });
  };
  handleGetConversation = (selectedUser) => {
    this.getConversation(selectedUser);
    this.setState({ selectedUser, isLoadedMore: false });
  };
  handleSendToConversation = () => {
    if (!isF(ROLE_ALIAS)) return false;

    let { messageInput, selectedUser, files } = this.state;

    // selected user
    let selectedUserId =
      selectedUser.user_id != this.state.USER_PARENT_ID
        ? selectedUser.user_id
        : selectedUser.friend_id;

    // files
    if (files) {
      this.handleSendFilesToConversation(selectedUserId);
    }

    this.socket.emit("message send conversation", {
      user_id: this.state.USER_PARENT_ID,
      friend_id: selectedUserId,
      message: messageInput,
      real_id: localStorage.getItem("user_id"),
    });
  };
  handleChatInputPress = (e) => {
    if (!isF(ROLE_ALIAS)) return false;

    if (e.key === "Enter") {
      this.handleSendButtonClick();
    }
  };
  handleChatInputChange = (e) => {
    if (!isF(ROLE_ALIAS)) return false;

    this.setState({
      messageInput: e.target.value,
    });
  };

  handleFacebookConversationsUpdate = (conversations) => {
    const unreadCount = conversations.filter((c) => !c.is_read).length;
    this.setState({ facebookUnreadCount: unreadCount });
  };
  handleSendButtonClick = () => {
    let { messageInput, selectedUser, files } = this.state;

    if (messageInput != null || files != null) {
      if (
        (messageInput && messageInput.length > 0) ||
        (files && files.length > 0)
      ) {
        if (selectedUser.sender_id) {
          // guest
          this.handleSendToConversationGuest();
        } else {
          this.handleSendToConversation();
        }

        this.setState({
          messageInput: "",
          menuActiveTab: "messages",
          files: null,
        });
      }
    }
  };

  // Menu
  toggleAppMenu = (tab) => {
    this.setState({
      menuActiveTab: tab,
    });
  };

  changeConversation = (selectedUser) => {
    this.setState(
      {
        selectedUser,
        conversationData: [],
        isFirstLoad: true,
      },
      () => {
        if (selectedUser.sender_id) {
          // guest
          this.handleGetConversationGuest(selectedUser);
        } else {
          this.handleGetConversation(selectedUser);
        }
      },
    );
  };

  isLoaded = (e) => {
    this.setState({ isFirstLoad: false });
  };

  handleSearchContact = (keyword) => {
    const { originalAllUsersData, originalInboxsData, menuActiveTab } =
      this.state;

    this.setState({
      searchKey: keyword,
    });

    if (keyword.length > 0) {
      // this.props.toggleAppMenu("contacts")

      let dataSearch = [];
      if (menuActiveTab == "contacts") {
        // allUsersData
        if (keyword[0] === "#") {
          // uuid
          dataSearch = originalAllUsersData.filter(
            (u) => ("#" + u.companyUUID).indexOf(keyword) >= 0,
          );
        } else {
          // name
          dataSearch = originalAllUsersData.filter(
            (u) =>
              (u.companyName &&
                u.companyName
                  .toLowerCase()
                  .indexOf(keyword.toLowerCase().trim()) >= 0) ||
              (u.fullname &&
                u.fullname
                  .toLowerCase()
                  .indexOf(keyword.toLowerCase().trim()) >= 0),
          );
        }

        this.setState({
          allUsersData: dataSearch,
        });
      } else {
        // inboxsData
        if (keyword[0] === "#") {
          // uuid
          dataSearch = originalInboxsData.filter(
            (u) => ("#" + u["friend.companyUUID"]).indexOf(keyword) >= 0,
          );
        } else {
          // name
          dataSearch = originalInboxsData.filter(
            (u) =>
              (u["friend.companyName"] &&
                u["friend.companyName"]
                  .toLowerCase()
                  .indexOf(keyword.trim().toLowerCase()) >= 0) ||
              (u["friend.fullname"] &&
                u["friend.fullname"]
                  .toLowerCase()
                  .indexOf(keyword.trim().toLowerCase()) >= 0) ||
              (u["user.companyName"] &&
                u["user.companyName"]
                  .toLowerCase()
                  .indexOf(keyword.trim().toLowerCase()) >= 0) ||
              (u["user.fullname"] &&
                u["user.fullname"]
                  .toLowerCase()
                  .indexOf(keyword.trim().toLowerCase()) >= 0),
          );
        }
        this.setState({
          inboxsData: dataSearch,
        });
      }
    } else {
      this.setState({
        allUsersData: this.state.originalAllUsersData,
        inboxsData: this.state.originalInboxsData,
      });
    }
  };

  handleAllMessageClick = (e, item) => {
    if (item.source === "facebook") {
      this.setState({
        mainActiveTab: "facebook",
        selectedFacebookConversationId: item.id, // We will use this in FacebookChatApp
      });
    } else {
      this.setState((prevState) => {
        // Optimistic Update: Mark the clicked item as seen (isSeen = 1)
        const updatedInboxs = prevState.inboxsData.map((inbox) => {
          // Assuming item.originalItem is passed, or we match by ID if item is standardized
          // But changeConversation takes the raw item usually (which is item.originalItem in All Tab)
          // Check if it's the same item.
          // Note: item passed here is 'originalItem' because handleAllMessageClick calls with item.originalItem from the render loop below.
          if (inbox.id === item.id) {
            return { ...inbox, isSeen: 1 };
          }
          return inbox;
        });

        return {
          mainActiveTab: "internal",
          inboxsData: updatedInboxs,
        };
      });
      this.changeConversation(item);
    }
  };

  // Callback for FacebookChatApp to push real-time conversation updates to parent
  handleFacebookConversationsUpdate = (conversations) => {
    if (conversations) {
      this.setState({ facebookConversations: conversations });
    }
  };

  render() {
    const {
      menuActiveTab,
      messageInput,
      inboxsData,
      conversationData,
      selectedUser,
      allUsersData,
      searchKey,
      files,
      isLoadedMore,
      isEndMessagesData,
      isFirstLoad,
      facebookConversations = [], // Ensure default value
    } = this.state;

    // Helper: Local checks for Unread status (Shared)
    const isItemUnread = (u) => {
      // If I am the sender, it's always "read" for me (not unread)
      const myId = this.state.USER_PARENT_ID || localStorage.getItem("b");
      if (u.sender_id == myId) return false;

      if (u.isSeen === 0 || u.isSeen === false) return true;
      return false;
    };

    // Helper to normalize message data for the "All" tab
    const getDisplayInfo = (item) => {
      if (item.source === "facebook") {
        return {
          id: item.id,
          source: "facebook",
          name: item.customer_name || "Facebook User",
          avatar: item.customer_profile_pic,
          message: item.last_message,
          // Facebook uses ISO timestamp
          timestamp: item.last_message_time || item.updated_at,
          is_read: item.is_read,
          displayTime: item.last_message_time || item.updated_at,
          originalItem: item,
        };
      } else {
        // Internal Message Normalization

        // Identify the partner: If I am sender, partner is friend. If I am receiver, partner is user.
        // Identify the partner: If I am sender, partner is friend. If I am receiver, partner is user.
        let target = item;
        const myId = this.state.USER_PARENT_ID || localStorage.getItem("b");
        const allContacts = this.state.allUsersData || [];

        let partnerId = null;

        if (item.user_id == myId) {
          // I am sender
          if (item.friend) target = item.friend;
          partnerId = item.friend_id;
        } else {
          // I am receiver
          if (item.user) target = item.user;
          partnerId = item.user_id;
        }

        // Fallback: If target is still item (nested object missing), try finding in allContacts
        // Check both id and user_id fields
        if (target === item && partnerId) {
          const foundContact = allContacts.find(
            (c) =>
              String(c.id) === String(partnerId) ||
              String(c.user_id) === String(partnerId),
          );
          if (foundContact) target = foundContact;
        }

        const name = target.fullname || target.name || item.name || "User";
        const avatar = target.avatar || item.avatar;
        const message = item.message || "";

        // Construct timestamp for sorting
        let timestamp = item.created_at;
        if (!timestamp && item.date && item.time) {
          timestamp = `${item.date} ${item.time}`;
        }

        return {
          id: item.id,
          source: "internal",
          name: name,
          avatar: avatar,
          message: message,
          timestamp: timestamp,
          is_read: !isItemUnread(item),
          displayTime: timestamp,
          originalItem: item,
        };
      }
    };

    // Merge and Sort
    let allMessagesList = [
      ...inboxsData.map((item) =>
        getDisplayInfo({ ...item, source: "internal" }),
      ),
      ...facebookConversations.map((item) =>
        getDisplayInfo({ ...item, source: "facebook" }),
      ),
    ].sort((a, b) => {
      const dateA = a.timestamp ? new Date(a.timestamp) : new Date(0);
      const dateB = b.timestamp ? new Date(b.timestamp) : new Date(0);
      return dateB - dateA;
    });

    // Apply Filters to "All" Tab
    if (this.state.filterUnread) {
      allMessagesList = allMessagesList.filter((item) => !item.is_read);
    }

    // console.log('conversationDataRoot: ', conversationData);

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            <IntlMessages id="chat.permission_denied" />
          </CardBody>
        </Card>
      );

    return (
      <Fragment>
        <Row className="app-file-list h-100">
          <Colxx xxs="12" md="9">
            {/* Main Tabs */}
            <Nav tabs className="separator-tabs ml-0 mb-4">
              {this.checkPermission("pro") && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.mainActiveTab === "all",
                      "nav-link": true,
                    })}
                    onClick={() => this.setState({ mainActiveTab: "all" })}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="simple-icon-layers mr-2" />
                    <IntlMessages
                      id="chat.all_messages"
                      defaultMessage="All Messages"
                    />
                  </NavLink>
                </NavItem>
              )}

              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.mainActiveTab === "internal",
                    "nav-link": true,
                  })}
                  onClick={() => this.setState({ mainActiveTab: "internal" })}
                  style={{ cursor: "pointer" }}
                >
                  <i className="simple-icon-bubble mr-2" />
                  <IntlMessages id="chat.internal_msg" />
                </NavLink>
              </NavItem>
              {this.checkPermission("pro") && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.mainActiveTab === "facebook",
                      "nav-link": true,
                    })}
                    onClick={() => this.setState({ mainActiveTab: "facebook" })}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="iconsminds-facebook mr-2"
                      style={{
                        color:
                          this.state.mainActiveTab === "facebook"
                            ? "#1877f2"
                            : "inherit",
                      }}
                    />
                    Tin nhắn Facebook
                    {this.state.facebookUnreadCount > 0 && (
                      <Badge color="danger" pill className="ml-2" style={{ fontSize: 10 }}>
                        {this.state.facebookUnreadCount}
                      </Badge>
                    )}
                  </NavLink>
                </NavItem>
              )}
              {this.checkPermission("pro") && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.mainActiveTab === "fb-comments",
                      "nav-link": true,
                    })}
                    onClick={() => this.setState({ mainActiveTab: "fb-comments" })}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="simple-icon-bubbles mr-2"
                      style={{
                        color:
                          this.state.mainActiveTab === "fb-comments"
                            ? "#1877f2"
                            : "inherit",
                      }}
                    />
                    <IntlMessages id="fb.comment.tab" />
                  </NavLink>
                </NavItem>
              )}
              {this.checkPermission("pro") && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.mainActiveTab === "fb-ads",
                      "nav-link": true,
                    })}
                    onClick={() => this.setState({ mainActiveTab: "fb-ads" })}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="simple-icon-chart mr-2"
                      style={{
                        color:
                          this.state.mainActiveTab === "fb-ads"
                            ? "#1877f2"
                            : "inherit",
                      }}
                    />
                    Quản lý Quảng cáo
                  </NavLink>
                </NavItem>
              )}
            </Nav>

            <TabContent activeTab={this.state.mainActiveTab}>
              {/* ALL Tab Content */}
              <TabPane tabId="all">
                <Row className="pr-4">
                  <Colxx xxs="12">
                    <Card className="h-100">
                      <CardBody className="p-0">
                        <PerfectScrollbar
                          options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                          }}
                          style={{ height: "75vh" }}
                        >
                          <div className="pt-4 pr-4 pl-4 pb-2">
                            {allMessagesList.map((item, index) => {
                              const isFacebook = item.source === "facebook";
                              return (
                                <div
                                  key={`${item.source}-${item.id || index}`}
                                  className="d-flex flex-row mb-1 border-bottom pb-3 mb-3 cursor-pointer"
                                  onClick={(e) =>
                                    this.handleAllMessageClick(
                                      e,
                                      item.originalItem,
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {/* Avatar Container with Fixed Dimensions - Prevents Layout Collapse */}
                                  <div
                                    className="mr-3 position-relative"
                                    style={{
                                      minWidth: 40,
                                      width: 40,
                                      height: 40,
                                    }}
                                  >
                                    <img
                                      alt={item.name}
                                      src={
                                        item.avatar &&
                                        item.avatar.includes("http")
                                          ? item.avatar
                                          : getAvatar(item.avatar)
                                      }
                                      className="img-thumbnail border-0 rounded-circle align-self-center xsmall"
                                      style={{
                                        width: 40,
                                        height: 40,
                                        objectFit: "cover",
                                        display: "block", // Ensure it takes space initially
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                        // Find the fallback sibling and show it
                                        const fallback =
                                          e.target.parentElement.querySelector(
                                            ".avatar-fallback",
                                          );
                                        if (fallback)
                                          fallback.style.display = "flex";
                                      }}
                                    />

                                    {/* Fallback Initials Badge */}
                                    <div
                                      className="avatar-fallback rounded-circle bg-primary align-items-center justify-content-center text-white align-self-center xsmall"
                                      style={{
                                        width: 40,
                                        height: 40,
                                        fontSize: 16,
                                        // Hidden by default if we attempted to load an image, otherwise shown
                                        display: "none",
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                      }}
                                    >
                                      {item.name
                                        ? item.name.charAt(0).toUpperCase()
                                        : "U"}
                                    </div>
                                    {/* Source Icon Badge */}
                                    <span
                                      className="position-absolute rounded-circle d-flex align-items-center justify-content-center text-white"
                                      style={{
                                        width: 16,
                                        height: 16,
                                        bottom: 0,
                                        right: 0,
                                        backgroundColor: isFacebook
                                          ? "#1877f2"
                                          : "#922c88", // FB blue or Theme color
                                        fontSize: 9,
                                        border: "1px solid white",
                                        zIndex: 10, // Ensure it's above avatar and fallback
                                      }}
                                    >
                                      <i
                                        className={
                                          isFacebook
                                            ? "iconsminds-facebook"
                                            : "simple-icon-bubble"
                                        }
                                      />
                                    </span>
                                  </div>

                                  <div className="d-flex flex-grow-1 min-width-zero">
                                    <div className="pl-0 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero w-100">
                                      <div className="min-width-zero w-100">
                                        <div className="d-flex justify-content-between">
                                          <p
                                            className={`mb-0 truncate ${!item.is_read ? "font-weight-bold" : ""}`}
                                          >
                                            {item.name}
                                          </p>
                                          <span className="text-muted text-small text-nowrap ml-2">
                                            {item.displayTime
                                              ? moment(item.displayTime, [
                                                  "YYYY-MM-DD HH:mm",
                                                  "YYYY-MM-DDTHH:mm:ss.SSSZ",
                                                ]).fromNow()
                                              : ""}
                                          </span>
                                        </div>
                                        <p
                                          className={`mb-0 truncate text-small ${!item.is_read ? "font-weight-bold text-dark" : "text-muted"}`}
                                        >
                                          {isFacebook ? (
                                            item.message
                                          ) : (
                                            <PreviewContent
                                              content={item.message}
                                            />
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                            {allMessagesList.length === 0 && (
                              <div className="text-center text-muted mt-5">
                                <IntlMessages
                                  id="chat.no_messages"
                                  defaultMessage="No messages found"
                                />
                              </div>
                            )}
                          </div>
                        </PerfectScrollbar>
                      </CardBody>
                    </Card>
                  </Colxx>
                </Row>
              </TabPane>

              {/* Internal Chat Tab */}
              <TabPane tabId="internal">
                <Row className="pr-4">
                  {/* Sidebar */}
                  <Colxx xxs="12" md="5" lg="4">
                    <Card className="h-100">
                      <CardBody
                        className="p-0 d-flex flex-column"
                        style={{ height: "75vh" }}
                      >
                        <div className="pt-3 pr-3 pl-3 pb-0 border-bottom">
                          <h6 className="mb-3 font-weight-bold">
                            <IntlMessages id="chat.internal_msg" />
                          </h6>
                          <div className="form-group mb-3">
                            <Input
                              type="text"
                              className="form-control rounded"
                              placeholder={this.props.intl.formatMessage({
                                id: "chat.search_placeholder",
                              })}
                              value={searchKey}
                              onChange={(e) =>
                                this.handleSearchContact(e.target.value)
                              }
                            />
                          </div>
                        </div>

                        <div
                          className="flex-grow-1 position-relative overflow-hidden"
                          // style={{ minHeight: 0 }}
                        >
                          <PerfectScrollbar
                            options={{
                              suppressScrollX: true,
                              wheelPropagation: false,
                            }}
                            style={{ height: "100%" }}
                          >
                            <div className="pt-2">
                              {(() => {
                                const processedList = [];
                                const seenIds = new Set();

                                // Helper: Get robust Partner ID (differentiates between MsgID and UserID)
                                const getPartnerId = (u) => {
                                  if (!u) return null;
                                  return (
                                    u.user_id ||
                                    u.friend_id ||
                                    u.sender_id ||
                                    u.id
                                  );
                                };

                                // Define VMASS Check
                                const isVmass = (u) => {
                                  if (!u) return false;
                                  const name = u.name || u.fullname;
                                  return (
                                    name === "VMASS" || name === "Hỗ trợ VMASS"
                                  );
                                };

                                // Helper: Local checks for Unread status
                                // Safer internal check defaulting to 'read' if isSeen is missing
                                const isItemUnread = (u) => {
                                  if (u.isSeen === 0 || u.isSeen === false)
                                    return true;
                                  return false;
                                };

                                // 1. Process Inbox Data
                                const inboxItems = inboxsData || [];

                                // Find VMASS User (Pinned)
                                let vmassUser = inboxItems.find(isVmass);
                                const vmassId = getPartnerId(vmassUser);

                                // Enhanced VMASS checker using ID if available
                                const isVmassOrSameId = (u) => {
                                  if (isVmass(u)) return true;
                                  if (vmassId && getPartnerId(u) === vmassId)
                                    return true;
                                  return false;
                                };

                                inboxItems.forEach((item) => {
                                  // Extract dedupe key: Prefer user_id (PartnerID) over id (MsgID)
                                  let key = getPartnerId(item);
                                  let finalKey = key || item.id;

                                  if (finalKey) finalKey = String(finalKey);

                                  if (finalKey && !seenIds.has(finalKey)) {
                                    seenIds.add(finalKey);
                                    // Filter out VMASS items logic
                                    if (!isVmassOrSameId(item)) {
                                      processedList.push(item);
                                    }
                                  }
                                });

                                // 2. Process Contacts (allUsersData)
                                // Contact items usually have id as UserID.
                                const contactItems = allUsersData || [];
                                if (!vmassUser) {
                                  vmassUser = contactItems.find(isVmass);
                                }
                                // Update ID if we just found it in contacts
                                const vmassIdForContacts =
                                  getPartnerId(vmassUser);
                                const isVmassOrSameIdContacts = (u) => {
                                  if (isVmass(u)) return true;
                                  if (
                                    vmassIdForContacts &&
                                    getPartnerId(u) === vmassIdForContacts
                                  )
                                    return true;
                                  return false;
                                };

                                contactItems.forEach((item) => {
                                  let key = item.id || item.user_id; // Contact User ID

                                  if (key) key = String(key);

                                  // Deduplicate: Check if this UserID is already in seenIds (from Inbox)
                                  if (key && !seenIds.has(key)) {
                                    seenIds.add(key);
                                    if (!isVmassOrSameIdContacts(item)) {
                                      processedList.push(item);
                                    }
                                  }
                                });

                                // Selection Logic
                                // STRICT CHECK: Only highlight VMASS item if the selected user identifies as VMASS
                                const isVmassSelected =
                                  selectedUser && isVmass(selectedUser);

                                const isVmassUnseen =
                                  vmassUser && isItemUnread(vmassUser);

                                return (
                                  <>
                                    {/* VMASS Item (Pinned Top) */}
                                    <div
                                      className={classnames(
                                        "d-flex align-items-center p-3 cursor-pointer",
                                        {
                                          "bg-light": isVmassSelected,
                                        },
                                      )}
                                      onClick={() =>
                                        vmassUser
                                          ? this.changeConversation(vmassUser)
                                          : null
                                      }
                                      style={{
                                        borderLeft: isVmassSelected
                                          ? "3px solid #0084ff"
                                          : "3px solid transparent",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {/* Avatar */}
                                      <div className="mr-3 position-relative">
                                        <img
                                          alt="VMASS"
                                          src="/assets/img/logo.jpeg"
                                          className="rounded-circle"
                                          style={{
                                            width: 48,
                                            height: 48,
                                            objectFit: "cover",
                                          }}
                                          onError={(e) => {
                                            e.target.src =
                                              "https://ui-avatars.com/api/?name=V&background=0D8ABC&color=fff";
                                          }}
                                        />
                                        {/* Unread dot */}
                                        {isVmassUnseen && (
                                          <span
                                            className="position-absolute bg-primary rounded-circle"
                                            style={{
                                              width: 12,
                                              height: 12,
                                              bottom: 0,
                                              right: 0,
                                              border: "2px solid white",
                                            }}
                                          />
                                        )}
                                      </div>

                                      {/* Content */}
                                      <div className="flex-grow-1 overflow-hidden">
                                        <div className="d-flex justify-content-between align-items-center">
                                          <h6
                                            className={`mb-0 text-truncate ${
                                              isVmassUnseen
                                                ? "font-weight-bold"
                                                : ""
                                            }`}
                                            style={{ maxWidth: "70%" }}
                                          >
                                            {vmassUser
                                              ? vmassUser.name ||
                                                vmassUser.fullname
                                              : "Hỗ trợ VMASS"}
                                          </h6>
                                          <small className="text-muted">
                                            {vmassUser && vmassUser.date
                                              ? moment(
                                                  vmassUser.date +
                                                    " " +
                                                    vmassUser.time,
                                                  [
                                                    "YYYY-MM-DD HH:mm",
                                                    "DD-MM-YYYY HH:mm",
                                                    "DD/MM/YYYY HH:mm",
                                                  ],
                                                ).fromNow()
                                              : ""}
                                          </small>
                                        </div>
                                        <p
                                          className={`mb-0 text-truncate small ${
                                            isVmassUnseen
                                              ? "font-weight-semibold text-dark"
                                              : "text-muted"
                                          }`}
                                        >
                                          {vmassUser && vmassUser.message && (
                                            <PreviewContent
                                              content={vmassUser.message}
                                            />
                                          )}
                                        </p>
                                      </div>
                                    </div>

                                    {/* Remaining List Items */}
                                    {processedList.map((item, index) => {
                                      // Resolve Target Partner (Handle both Contacts and Inbox Items)
                                      let target = item;
                                      const myId =
                                        this.state.USER_PARENT_ID ||
                                        localStorage.getItem("b");
                                      const allContacts =
                                        this.state.allUsersData || [];

                                      let partnerId = null;

                                      // If it's an inbox item (has friend/user objects), resolve the partner
                                      if (item.user_id && item.friend_id) {
                                        if (item.user_id == myId) {
                                          if (item.friend) target = item.friend;
                                          partnerId = item.friend_id;
                                        } else {
                                          if (item.user) target = item.user;
                                          partnerId = item.user_id;
                                        }
                                      } else {
                                        // Maybe it's a contact or raw item
                                        target = item;
                                      }

                                      // Fallback for Inbox items: If target is still item and we have partnerId
                                      if (target === item && partnerId) {
                                        const foundContact = allContacts.find(
                                          (c) =>
                                            String(c.id) ===
                                              String(partnerId) ||
                                            String(c.user_id) ===
                                              String(partnerId),
                                        );
                                        if (foundContact) target = foundContact;
                                      }

                                      const displayName =
                                        target.fullname ||
                                        target.name ||
                                        item.fullname ||
                                        item.name ||
                                        "User";
                                      const displayAvatar =
                                        target.avatar || item.avatar;
                                      // Message content usually sits on the root item for inbox items
                                      const displayMessage = item.message || "";
                                      const displayDate = item.date;
                                      const displayTime = item.time;

                                      // Use getPartnerId for robust comparison
                                      const userPartnerId = getPartnerId(item);
                                      const selectedPartnerId =
                                        getPartnerId(selectedUser);

                                      const isSelected =
                                        selectedUser &&
                                        !isVmass(selectedUser) &&
                                        selectedPartnerId === userPartnerId;

                                      const isUnread = isItemUnread(item);

                                      return (
                                        <div
                                          key={index}
                                          className={classnames(
                                            "d-flex align-items-center p-3 cursor-pointer",
                                            {
                                              "bg-light": isSelected,
                                            },
                                          )}
                                          onClick={() =>
                                            this.changeConversation(item)
                                          }
                                          style={{
                                            borderLeft: isSelected
                                              ? "3px solid #0084ff"
                                              : "3px solid transparent",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div className="mr-3 position-relative">
                                            <img
                                              alt={displayName}
                                              src={getAvatar(displayAvatar)}
                                              className="rounded-circle"
                                              style={{
                                                width: 48,
                                                height: 48,
                                                objectFit: "cover",
                                              }}
                                              onError={(e) => {
                                                e.target.src =
                                                  "/assets/img/default-avatar-vmass.png";
                                              }}
                                            />
                                            {/* Unread dot */}
                                            {isUnread && (
                                              <span
                                                className="position-absolute bg-primary rounded-circle"
                                                style={{
                                                  width: 12,
                                                  height: 12,
                                                  bottom: 0,
                                                  right: 0,
                                                  border: "2px solid white",
                                                }}
                                              />
                                            )}
                                          </div>

                                          <div className="flex-grow-1 overflow-hidden">
                                            <div className="d-flex justify-content-between align-items-center">
                                              <h6
                                                className={`mb-0 text-truncate ${
                                                  isUnread
                                                    ? "font-weight-bold"
                                                    : ""
                                                }`}
                                                style={{ maxWidth: "70%" }}
                                              >
                                                {displayName}
                                              </h6>
                                              <small className="text-muted">
                                                {displayDate &&
                                                  moment(
                                                    displayDate +
                                                      " " +
                                                      displayTime,
                                                    [
                                                      "YYYY-MM-DD HH:mm",
                                                      "DD-MM-YYYY HH:mm",
                                                      "DD/MM/YYYY HH:mm",
                                                    ],
                                                  ).fromNow()}
                                              </small>
                                            </div>
                                            <p
                                              className={`mb-0 text-truncate small ${
                                                isUnread
                                                  ? "font-weight-semibold text-dark"
                                                  : "text-muted"
                                              }`}
                                            >
                                              {displayMessage && (
                                                <PreviewContent
                                                  content={displayMessage}
                                                />
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })()}
                            </div>
                          </PerfectScrollbar>
                        </div>
                      </CardBody>
                    </Card>
                  </Colxx>

                  {/* Chat Area */}
                  <Colxx xxs="12" md="7" lg="8">
                    <Card className="h-100">
                      <CardBody
                        className="px-3 py-0 d-flex flex-column"
                        style={{ height: "75vh" }}
                      >
                        {selectedUser ? (
                          <>
                            <ChatHeading item={selectedUser} />
                            <div
                              className="flex-grow-1 position-relative overflow-hidden"
                              style={{ minHeight: 0 }}
                            >
                              <PerfectScrollbar
                                className="h-100"
                                onYReachStart={(container) => {
                                  if (!isEndMessagesData)
                                    container.scrollTop = 63 * 8 - 33;

                                  if (
                                    isLoadedMore &&
                                    !isEndMessagesData &&
                                    !isFirstLoad
                                  ) {
                                    setTimeout(() => {
                                      if (selectedUser.sender_id) {
                                        this.handleGetConversationGuest(
                                          selectedUser,
                                        );
                                      } else {
                                        this.handleGetConversation(
                                          selectedUser,
                                        );
                                      }
                                    }, 1);
                                  }

                                  if (isFirstLoad) {
                                    this.isLoaded();
                                  }
                                }}
                                ref={(ref) => {
                                  this._scrollBarRef = ref;
                                }}
                                options={{
                                  suppressScrollX: true,
                                  wheelPropagation: false,
                                }}
                              >
                                <div>
                                  {conversationData.map((item, idx) => (
                                    <div key={idx} ref={`message_${idx}`}>
                                      <MessageCard idx={idx} item={item} />
                                    </div>
                                  ))}
                                </div>
                              </PerfectScrollbar>
                            </div>
                            <div className="p-3 border-top">
                              <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                  <Button
                                    color="link"
                                    className="text-muted px-2"
                                    onClick={() => this.fileInput.click()}
                                    title="Đính kèm tệp"
                                  >
                                    <i
                                      className="simple-icon-paper-clip"
                                      style={{ fontSize: "1.2rem" }}
                                    />
                                  </Button>
                                  <input
                                    multiple
                                    accept=".zip, .rar, .tar, .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                                    type="file"
                                    ref={(ref) => (this.fileInput = ref)}
                                    style={{ display: "none" }}
                                    onChange={this.onChangeFile}
                                  />
                                </InputGroupAddon>
                                <Input
                                  type="text"
                                  className="form-control rounded-pill bg-light border-0 px-3"
                                  placeholder="Viết tin nhắn..."
                                  value={messageInput}
                                  onChange={this.handleChatInputChange}
                                  onKeyPress={this.handleChatInputPress}
                                  disabled={!isF(ROLE_ALIAS)}
                                />
                                <InputGroupAddon addonType="append">
                                  <Button
                                    color="primary"
                                    className="rounded-circle ml-2 d-flex align-items-center justify-content-center shadow-sm"
                                    style={{
                                      width: 38,
                                      height: 38,
                                      padding: 0,
                                    }}
                                    onClick={this.handleSendButtonClick}
                                    disabled={
                                      (!messageInput ||
                                        messageInput.trim() === "") &&
                                      (!files || files.length === 0)
                                    }
                                  >
                                    <i className="simple-icon-paper-plane" />
                                  </Button>
                                </InputGroupAddon>
                              </InputGroup>
                              {files && files.length > 0 && (
                                <div className="mt-2 d-flex align-items-center ml-2">
                                  {/* Display file count or list */}
                                  <span className="badge badge-outline-primary badge-pill mr-2">
                                    {files.length} tệp được chọn
                                  </span>
                                  <i
                                    className="simple-icon-close text-muted cursor-pointer"
                                    style={{ fontSize: "12px" }}
                                    onClick={this.onSelectedFile}
                                    title="Bỏ chọn"
                                  />
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                            <i
                              className="simple-icon-bubble mb-3"
                              style={{ fontSize: 60 }}
                            />
                            <p>
                              <IntlMessages id="chat.start-conversation" />
                            </p>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Colxx>
                </Row>
              </TabPane>

              {/* Facebook Chat Tab */}
              <TabPane tabId="facebook">
                <FacebookChatApp
                  detailsConversationId={
                    this.state.selectedFacebookConversationId
                  }
                  filterUnread={this.state.filterUnread}
                  onConversationsUpdate={this.handleFacebookConversationsUpdate}
                  activeTab={this.state.mainActiveTab}
                />
              </TabPane>

              {/* Facebook Comments Tab */}
              <TabPane tabId="fb-comments">
                <FacebookCommentApp
                  activeTab={this.state.mainActiveTab}
                />
              </TabPane>

              {/* Facebook Ads Integration Tab */}
              <TabPane tabId="fb-ads">
                <Row className="pr-4">
                  <Colxx xxs="12">
                    <Card className="h-100">
                      <CardBody className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "75vh" }}>
                        <i className="simple-icon-chart text-primary mb-4" style={{ fontSize: 70 }} />
                        <h4 className="font-weight-bold mb-3">Tích hợp Trình Quản lý Quảng cáo Facebook</h4>
                        <p className="text-muted mb-4" style={{ maxWidth: 500 }}>
                          Theo dõi, phân tích và tối ưu hóa các chiến dịch quảng cáo Facebook trực tiếp từ VMASS. Trải nghiệm hệ thống báo cáo chuyên sâu với dữ liệu theo thời gian thực tại không gian làm việc chuyên dụng.
                        </p>
                        <Button
                          color="primary"
                          size="lg"
                          className="btn-multiple-state"
                          onClick={async () => {
                            const currentHost = window.location.hostname;
                            const isLocal = currentHost.includes("localhost");
                            const port = window.location.port ? `:${window.location.port}` : '';
                            const protocol = isLocal ? "http://" : "https://";
                            const domain = isLocal ? `marketing.localhost${port}` : "marketing.vmass.vn";
                            const redirectUrl = `${protocol}${domain}`;
                            try {
                              window.open(
                                await createAuthHandoffUrl(
                                  redirectUrl,
                                  buildStoredAuthPayload(),
                                ),
                                "_blank",
                              );
                            } catch (error) {
                              console.error("Error creating auth handoff:", error);
                              NotificatioErrController("Không thể chuyển phiên đăng nhập");
                            }
                          }}
                        >
                          <span className="spinner d-inline-block">
                            <span className="bounce1" />
                            <span className="bounce2" />
                            <span className="bounce3" />
                          </span>
                          <span className="icon success">
                            <i className="simple-icon-check" />
                          </span>
                          <span className="icon fail">
                            <i className="simple-icon-exclamation" />
                          </span>
                          <span className="label">Chuyển đến Quảng Cáo VMASS <i className="simple-icon-action-redo ml-2" /></span>
                        </Button>
                      </CardBody>
                    </Card>
                  </Colxx>
                </Row>
              </TabPane>
            </TabContent>
          </Colxx>

          {/* Right Filter Column (Persistent) */}
          <Colxx xxs="12" md="3" className="pl-0 pr-0">
            <Card className="h-100 border-left">
              <CardBody>
                <h5 className="mb-4 text-primary font-weight-bold">
                  <i className="simple-icon-equalizer mr-2" />
                  <IntlMessages id="chat.filters" />
                </h5>

                {/* Unread Switch */}
                <div className="d-flex justify-content-between align-items-center mb-4 p-3 rounded">
                  <span className="font-weight-semibold">
                    <IntlMessages id="chat.unread_only" />
                  </span>
                  <Switch
                    className="custom-switch custom-switch-primary"
                    checked={this.state.filterUnread}
                    onChange={this.toggleUnreadFilter}
                  />
                </div>

                <div className="separator mb-4" />

                <h6 className="mb-3 font-weight-bold">
                  <IntlMessages id="chat.tags" />
                </h6>
                <div className="d-flex flex-wrap">
                  <span
                    className="badge badge-pill badge-outline-primary mb-2 mr-1 p-2 cursor-pointer"
                    style={{ fontSize: "85%" }}
                  >
                    <IntlMessages id="chat.tag_important" />
                  </span>
                  <span
                    className="badge badge-pill badge-outline-warning mb-2 mr-1 p-2 cursor-pointer"
                    style={{ fontSize: "85%" }}
                  >
                    <IntlMessages id="chat.tag_pending" />
                  </span>
                  <span
                    className="badge badge-pill badge-outline-success mb-2 mr-1 p-2 cursor-pointer"
                    style={{ fontSize: "85%" }}
                  >
                    <IntlMessages id="chat.tag_customer" />
                  </span>
                  <span
                    className="badge badge-pill badge-outline-info mb-2 mr-1 p-2 cursor-pointer"
                    style={{ fontSize: "85%" }}
                  >
                    <IntlMessages id="chat.tag_new_lead" />
                  </span>
                  <span
                    className="badge badge-pill badge-outline-danger mb-2 mr-1 p-2 cursor-pointer"
                    style={{ fontSize: "85%" }}
                  >
                    <IntlMessages id="chat.tag_closed" />
                  </span>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default injectIntl(ChatApp);
